import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

//通过 Status 和时间条件给 badge 的 BackgroundColor 赋值
export function checkPopUpNote({ parameter, pageComponent } = {}) {
  let popupNoteIconShow = false;
  let popupNoteShow = false;
  let popUpNotes = [];
  // 新增、编辑后的列表重载沿用当前 Job Detail 页面的展开状态
  if (pageComponent?.state?.jobNoteContentExpanded === true) {
    parameter.forEach(item => { item.showFullContent = true; });
  }
  parameter.map((item, i) => {
    if (item.Popup) {
      popupNoteIconShow = true;
      popupNoteShow = true;
      popUpNotes.push(item);
    }
  })
  if (pageComponent.state.popupNoteShow === null) {
    pageComponent.setState({ popupNoteShow });
  }
  pageComponent.setState({ popupNoteIconShow, popUpNotes });
  globalFunction.getSectionComponent(pageComponent, 'Job')?.getSectionDataByDefault();
}

export function loadNoteTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (parameter > 0) {
    const jobId = pageComponent?.state?.jobData?.JobId ?? sectionComponent?.props?.searchParameter?.jobId;
    // Job 详情中按 Email Template 的方式执行 MailMerge；无 Job 上下文时保留原有模板装载行为。
    const url = jobId ? 'Admin/NoteTemplate/GetMailMergeDetail/' + parameter + '?jobId=' + jobId : 'Admin/NoteTemplate/' + parameter;
    httpClient
      .get(url)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ Content: data.data.Content, ClientPortal: data.data.ClientPortal, Popup: data.data.Popup });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//打开 JobNote 的回收站
export function openRecycleBin({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ jobNoteRecycleBinShow: true });
  let searchParameter = { ...sectionComponent.state.searchParameter };
  let jobId = sectionComponent.props.searchParameter.jobId;
  httpClient
    .get('/Business/JobNote/GetRecycleBinList?jobId=' + jobId)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.jobNoteRecycleBin.current?.setState({ data: data.data, selectedRowKeys: [] });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function filterContent({ parameter, sectionComponent, formComponent, pageComponent, sectionName, uie } = {}) {
  parameter = parameter.trim(); //去首尾空格
  // parameter = parameter.replace(/\s/g, ''); //去所有空格
  if (parameter) {
      const filteredJobNote = pageComponent.state.sectionData.JobNote.filter(item => {
          if (item.Content) {
              const cleanContent = item.Content.replace(/<[^>]*>/g, '');
              return cleanContent.toLowerCase().includes(parameter.toLowerCase());
          }
          return false;
      });
      sectionComponent.child.current.setState({ data: filteredJobNote });
  } else {
      sectionComponent.child.current.setState({ data: pageComponent.state.sectionData.JobNote });
  }
}

// 展开当前 Note 列表中所有被截断的 Content
export function expandAllContent({ sectionName, sectionComponent, pageComponent } = {}) {
  // TabSection 下的 child 是多个 ItemChildren ref，默认 Section 下则直接是表格 ref。
  const tableComponent = Array.isArray(sectionComponent?.child)
    ? sectionComponent.child.find(child => child.current?.props?.sectionName === sectionName)?.current?.child?.current
    : sectionComponent?.child?.current;
  if (tableComponent === undefined || tableComponent === null) {
    return;
  }

  const expandContent = (notes = []) => notes.map(note => ({ ...note, showFullContent: true }));
  tableComponent.setState({ data: expandContent(tableComponent.state.data) });
  pageComponent?.setState({ jobNoteContentExpanded: true });

  // 保留筛选功能的展开状态，避免筛选后重新显示截断文本。
  if (pageComponent?.state?.sectionData?.JobNote !== undefined) {
    pageComponent.setState({
      sectionData: {
        ...pageComponent.state.sectionData,
        JobNote: expandContent(pageComponent.state.sectionData.JobNote)
      }
    });
  }
}

export function viewNote({ parameter, pageComponent } = {}) {
  pageComponent.setState({ viewNoteShow: true });
  setTimeout(() => {
    pageComponent.viewNote.current?.setState({ data: parameter.Content });
  }, config.setTimeoutMilliSecond);
}

export function addSubmitFinish({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.getSectionComponent(pageComponent, 'Job')?.getSectionDataByDefault();
  globalFunction.getSectionComponent(pageComponent, 'JobStatusChange')?.getSectionDataByDefault();
}
